import { Component, OnInit, Input, AfterViewInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { NgbModal, NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import {FormGroup,FormControl,Validators,FormArray,FormBuilder} from '@angular/forms';
import {IncidentMessageDetailsComponent} from '../incident-message-details/incident-message-details.component';
import {StandardUIService} from '../../../services/standardui-service/standardui-service';
import { EmailNoteService } from '../../../services/emailnote/emailnote-services';
import { Subscription } from 'rxjs';
import { ApiserviceService } from 'src/app/Service/apiservice.service';
import { LocalStorageService } from 'src/app/services/localstorage-service/localstorage-service';
@Component({
  selector: 'app-incident-messages',
  templateUrl: './incident-messages.component.html',
  styleUrls: ['./incident-messages.component.scss']
})
export class IncidentMessagesComponent implements OnInit {
  private subscriptions: Subscription[] = [];
  /** Multi Access location: Email / Customer Entry / Notes actions disabled. */
  isMultiAccess = false;
  constructor(
    private emailNoteService:EmailNoteService,
    private modalService: NgbModal,
    private kbs:ApiserviceService,
    private formBuilder: FormBuilder,
    public standardUIService:StandardUIService,
    private localStorageService: LocalStorageService
  ) { }
  modalRefernce:any;
  @Input() emailNotesData;
  @Input() entityData;
  ngOnInit() {
    this.isMultiAccess = this.resolveIsMultiAccess();
    if(this.emailNotesData){
      //console.log(this.emailNotesData);
    }
     //2021-07-16T07:07:47.168+0000
     //console.log(this.standardUIService.getDateByFormat('2021-07-16T07:07:47.168+0000','/','mdy'))
    //return false;
    this.standardUIService.castIncident.subscribe((val:any)=>{
        //console.log(val);
        if(val.saved == 'true' && (val.enityId == this.entityData.id)){
          this.refreshComp();
        }
    })
  }

  private resolveIsMultiAccess(): boolean {
    try {
      const user = JSON.parse(this.localStorageService.get('currentUser') || 'null');
      return user?.location?.locationname === 'Multi Access'
        || localStorage.getItem('locationname') === 'Multi Access';
    } catch {
      return localStorage.getItem('locationname') === 'Multi Access';
    }
  }

  openDetails(type,item){
    // Email (2) / Customer Entry (3) / Notes (1) blocked for Multi Access
    if (this.isMultiAccess && (type === '1' || type === 1 || type === '2' || type === 2 || type === '3' || type === 3)) {
      return;
    }
    // this.modalRefernce = this.modalService.open(IncidentMessageDetailsComponent, { windowClass: 'modal-xl animate incident-detail' });
    // this.modalRefernce.componentInstance.type = type;
    // this.modalRefernce.componentInstance.modalRef = this.modalRefernce;


    this.standardUIService.setIncidentEmailOrNote({"type":type,"open":true,'item':item});
$(".preview-submit").hide();
  }

  getfileName(imgUrl: string): string {
    // console.log(imgUrl)
    // let arr: any = imgUrl.split('sections/')[1].split('_');

    // return arr[1].split('/')[1]+arr[2]+arr[3]+arr[5].split('.')[1];

    const filename = imgUrl.substring(imgUrl.lastIndexOf('/') + 1);

    const lastUnderscorePos = filename.lastIndexOf('_');
    const secondLastUnderscorePos = filename.lastIndexOf('_', lastUnderscorePos - 2);

    const baseName = filename.substring(0, secondLastUnderscorePos);

    const extension = filename.split('.').pop();

    return `${baseName}.${extension}`;
  }
  refreshComp(){
    if(this.entityData.id > 0){
      this.subscriptions.push(this.emailNoteService.getIncidentNotes(this.entityData.entityName,this.entityData.id).subscribe((result:any)=>{
        this.emailNotesData = result;
      }))
    }
  }
  dateConvert(date){
    return this.standardUIService.convertToEST(date);
  }
  striphtml(html){
    return html.replace(/<[^>]*>?/gm, ''); // replaced tags
  }

  changeIcon($event: NgbPanelChangeEvent, acc) {
    $('.expand-icon').removeClass('fa-caret-down').addClass('fa-caret-right');
    if (!acc.isExpanded($event.panelId)) {
      //this.icon = true;
      $("[aria-controls='"+$event.panelId+"']").find('.expand-icon').removeClass('fa-caret-right').addClass('fa-caret-down');
    } else {
      //this.icon = false;
      $("[aria-controls='"+$event.panelId+"']").find('.expand-icon').removeClass('fa-caret-down').addClass('fa-caret-right');
    }
  }
  ngOnDestroy(){
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
